import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MomentModule } from 'ngx-moment';
import { RouterModule } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { DirectivesModule } from '../../../../components/directives.module';
import { WaitingCallComponent } from './waiting-call.component';
import { WaitingCallsActionComponent } from './waiting-call-action/waiting-call-action';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    MatAutocompleteModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatSelectModule,
    MomentModule,
    RouterModule,
    AgGridAngular,
  ],
  declarations: [WaitingCallComponent, WaitingCallsActionComponent],
  exports: [WaitingCallComponent, WaitingCallsActionComponent],
})
export class WaitingCallModule {
}
